import React, { Component } from "react";

import "./index.scss";

class Column extends Component {
  render() {
    return (
      <div className="Column">
        <div className="CBorder">
          党的二十大擘画了以中国式现代化全面推进中华民族伟大复兴的宏伟蓝图。
          新华网联合中央党校（国家行政学院）国家高端智库，
          推出“思客讲堂·党校公开课（第四季）”《二十大报告里看未来｜如何理解“中国式现代化”》，
          五位党校青年教师通过五集理论短视频，带你探寻中国式现代化。
        </div>
        <div className="al"></div>
        <div className="ar"></div>
      </div>
    );
  }
}

export default Column;
